module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAAA0klEQVQokXXPPUoDQRgG4CfJNFliShEEK0FSWGk6G3MCO4sUgsWCHkJCDmFhIQjqGew8gF5AsAxqo41W/qCFs/i5ZD8YmHfm4WWmVZZlgSFWsYepvznCGe5xk3CFD7QwQBnwAOO876TcuIweNnEd8DZu8YaHlFu/8VqDK3jO5/CewuUB+iEvYR87VUnEW1gMuYcFrM/D45w/c17DBi4r0A64g/OQ7yKs4wl28VJbJxWIzzjO+ND/eZqHHzHCTMO00UWRcxMs0E24yK1fTY1+P3/6A2ACKHx0NkULAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back/nav/dd.png
// module id = ktLv
// module chunks = 1